import dayjs, { Dayjs } from 'dayjs';
import { useCallback, useState } from 'react';
import { NoOpsSelected, PageError, PageLoading } from '../../../../components';
import { Alert, AlertDescription } from '../../../../components/ui/alert';
import { useOps } from '../../../../hooks/useOps';
import { StatisticsCharts, StatisticsFaq, StatisticsHeader } from './components';
import { useStatistics } from './hooks';

export function RomaneioStatistics() {
  const { currentOps } = useOps();
  const [filterDate, setFilterDate] = useState<Dayjs>(dayjs());

  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    hasData,
    refetch,
    enabled,
  } = useStatistics(filterDate.format('YYYY-MM-DD'));

  const handleFilterDateChange = useCallback((date: Dayjs) => {
    setFilterDate(date);
  }, []);

  const handleRefresh = useCallback(() => {
    refetch();
  }, [refetch]);

  if (!currentOps) {
    return (
      <NoOpsSelected message="Selecione uma operação para visualizar as estatísticas." />
    );
  }

  return (
    <div className="space-y-6">
      <StatisticsHeader
        filterDate={filterDate}
        onFilterDateChange={handleFilterDateChange}
        onRefresh={handleRefresh}
        isRefreshing={isFetching}
      />

      <PageError error={error?.message || (isError ? 'Erro ao carregar estatísticas' : null)} />

      <StatisticsFaq />

      <PageLoading loading={isLoading} message="Carregando estatísticas..." />

      {!isLoading && hasData && <StatisticsCharts data={data} />}

      {!isLoading && !hasData && enabled && (
        <Alert className="border-[hsl(214,32%,91%)] bg-white">
          <AlertDescription className="text-[hsl(215,16%,47%)]">
            Nenhum dado encontrado para o período selecionado.
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
}
